var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 95",
    width: 98,
    height: 95,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-738-1998h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#5d5b68}.b{fill:#848792}.c{fill:#e6e9ee}.d{fill:#c8ced6}.e{fill:#2c92bf}.f{fill:#4ec4a5}.g{fill:#30aa87}.h{fill:#e1533b}.i{fill:#f8ce01}.j{fill:#5f6fe7}.k{fill:#6e7fed}.l{fill:#1f81a3}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m35.2 75.1h26.9l6.3 12.4h-39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m23.8 87.5h49.8v6.6h-49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m91.9 1h-86.4c-3 0-5.5 2.5-5.5 5.5v57.2h97.4v-57.2c0-3-2.5-5.5-5.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m92.6 1.1c0 0.2 0.1 0.4 0.1 0.7 0 33-25.5 59.8-56.9 59.8h-35.8v5h97.4v-59.9c0-2.9-2.1-5.3-4.8-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m0 62.9v7.6c0 3.1 2.5 5.7 5.5 5.7h86.4c3 0 5.5-2.6 5.5-5.7v-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m69 18.8h7.9v38h-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m51.8 56.1h-8v-21.5h8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m81.1 34.6h8v21.5h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m89.1 56.1h-3.3v-21.5h3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m64.3 55.8h-7.9v-11.6h7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m25.4 9.3q-0.2 0-0.3 0c-9.3 0-16.8 7.5-16.8 16.8 0 4.7 1.9 9 5.1 12l12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m13.4 36.6c3 3 7.1 4.8 11.7 4.8 9.2 0 16.8-7.5 16.8-16.8h-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m24 9.3v16.8h16.4c0-9.2-7.3-16.6-16.4-16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m48.7 71.3c-0.9 0-1.7-0.7-1.7-1.6 0-0.9 0.8-1.7 1.7-1.7 0.9 0 1.6 0.8 1.6 1.7 0 0.9-0.7 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m36.5 51.7h-28.2c-1 0-1.7-0.8-1.7-1.7 0-0.9 0.7-1.6 1.7-1.6h28.2c0.9 0 1.6 0.7 1.6 1.6 0 0.9-0.7 1.7-1.6 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m25.4 57.2h-17.1c-1 0-1.7-0.8-1.7-1.7 0-0.9 0.7-1.6 1.7-1.6h17.1c0.9 0 1.7 0.7 1.7 1.6 0 0.9-0.7 1.7-1.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m64.2 55.8h-3.3v-11.6h3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m77.3 56.8h-3.3v-38h3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m50.7 56.8h-3.3v-21.5h3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.5c409444c0d6f308b40912ebf6e479ec.svg";
export { ForwardRef as ReactComponent };